module.exports = __webpack_public_path__ + "img/office-screen-01.ac7f3535.jpg";